import { useState, useCallback } from 'react';
import { getBaseRpcEndpointsWithMetadata, type RpcEndpoint } from '../utils/rpc-endpoints.ts';

// Get RPC endpoints from shared configuration
const DEFAULT_BASE_RPC_ENDPOINTS: RpcEndpoint[] = getBaseRpcEndpointsWithMetadata();

export const useRpcEndpoint = () => {
  const [currentEndpoint, setCurrentEndpoint] = useState<RpcEndpoint>(DEFAULT_BASE_RPC_ENDPOINTS[0]);
  const [endpoints] = useState<RpcEndpoint[]>(DEFAULT_BASE_RPC_ENDPOINTS);

  const switchToEndpoint = useCallback((endpoint: RpcEndpoint) => {
    setCurrentEndpoint(endpoint);
  }, []);

  const switchToNextEndpoint = useCallback(() => {
    const currentIndex = endpoints.findIndex(ep => ep.url === currentEndpoint.url);
    const nextIndex = (currentIndex + 1) % endpoints.length;
    setCurrentEndpoint(endpoints[nextIndex]);
  }, [currentEndpoint.url, endpoints]);

  const getEndpointByPriority = useCallback((priority: number) => {
    return endpoints.find(ep => ep.priority === priority) || endpoints[0];
  }, [endpoints]);

  return {
    currentEndpoint,
    endpoints,
    switchToEndpoint,
    switchToNextEndpoint,
    getEndpointByPriority,
  };
};
